import { Component, OnInit } from '@angular/core';
import { BaselinkerService } from './baselinker.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogRefreshTokenService } from './dialog-refresh-token/dialog-refresh-token.service';
import { hasApiKeyPermission } from '../config/navigation.config';
import { OAuthService } from 'angular-oauth2-oidc';
import { KnsSnackbarService } from '@kns-jasfbg/kns-snackbar';

@Component({
    selector: 'app-token-baselinker-page',
    templateUrl: './token-baselinker-page.component.html',
    styleUrls: ['./token-baselinker-page.component.scss'],
    standalone: false
})
export class TokenBaselinkerPageComponent implements OnInit {

  token!: string;
  loadingToken = true;
  public hasPermission = false;
  constructor(private baselinkerService: BaselinkerService, private snackbar: KnsSnackbarService, public translate: TranslateService, public dialogService: DialogRefreshTokenService, public oauthService: OAuthService) {
    const claims = this.oauthService.getIdentityClaims();
    this.hasPermission = hasApiKeyPermission(claims['extranet_modules_users_permissions'])
  }

  ngOnInit(): void {
    this.token = this.translate.instant('errorLoadingToken');
    if (this.hasPermission) {
      this.getBaselinkerToken();
    }
  }

  private getBaselinkerToken() {
    this.baselinkerService.getToken().subscribe({
      next: data => {
        this.loadingToken = false;
        this.token = data.apiKey;
      },
      error: error => {
        if (error.status == 404) {
          this.regenerateToken();
        } else {
          this.loadingToken = false;
          this.snackbar.openError({message: this.translate.instant('errorGetToken'), closeButton: true, duration: 3000, verticalPosition: 'top' });
        }
      }
    });
  }

  startTokenRegeneration() {
    this.dialogService.openConfirmRefreshTokenDialog().afterClosed().subscribe(res => {
      if (res) {
        this.regenerateToken();
      }
    })
  }

  regenerateToken() {
    this.loadingToken = true;
    this.baselinkerService.refreshToken().subscribe({
      next: data => {
        this.loadingToken = false;
        this.token = data.apiKey;
      },
      error: error => {
        this.loadingToken = false;
        this.snackbar.openError({message: this.translate.instant('errorRefreshToken'), closeButton: true, duration: 3000 });
      }
    })
  }

}
